import type { FC, PropsWithChildren } from "react";
import { createContext, useContext, useMemo, useState } from "react";

export enum LoginModalView {
    Login,
    Registration,
    ForgetPassword,
    NewPassword,
    MigrationPasswordChange,
    UserHasSocialAccount,
}

interface IHeaderStatusContext {
    reCaptchaPublicToken: string;
    activeLoginModal: LoginModalView | null;
    setActiveLoginModal: (view: LoginModalView | null) => void;
}

export const ActiveLoginModalContext = createContext<IHeaderStatusContext>(null);

export const useActiveLoginModalContext = () => useContext(ActiveLoginModalContext);

export const ActiveLoginModalContextProvider: FC<
    PropsWithChildren<{ viewModal: LoginModalView | null; reCaptchaPublicToken: string }>
> = ({ children, viewModal, reCaptchaPublicToken }) => {
    const [activeLoginModal, setActiveLoginModal] = useState<LoginModalView | null>(viewModal);

    const context = useMemo(
        () => ({ reCaptchaPublicToken, activeLoginModal, setActiveLoginModal }),
        [reCaptchaPublicToken, activeLoginModal, setActiveLoginModal],
    );

    return <ActiveLoginModalContext.Provider value={context}>{children}</ActiveLoginModalContext.Provider>;
};
